module.exports = __webpack_public_path__ + "img/report_fx.74c679c1.png";